var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"uploader"}},[(_vm.isMobile)?_c('div',[_c('router-view')],1):_vm._e(),_vm._v(" "),(!_vm.isMobile)?_c('div',[_c('p',[_vm._v("请您使用手机访问")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }